<template>
  <header class="header header--6">
    <div class="container container-xl">
      <nav class="navbar d-none d-xl-flex" :class="{'navbar--books': isPortalTypeBooks}">
        <navbar-logo/>
        <main-nav />
        <div class="side-menu">
          <profile-link />
          <login-btn/>
        </div>
      </nav>
      <nav class="d-flex d-xl-none align-items-center">
        <navbar-logo/>
        <div
          class="mobile-menu"
          :class="{ 'open': menuIsOpen }"
        >
          <main-nav/>
          <div class="side-menu">
            <profile-link />
            <login-btn/>
          </div>
        </div>

        <button
            class="btn btn-menu d-xl-none"
            @click="menuIsOpen = !menuIsOpen"
            :class="{ 'is-active': menuIsOpen }"
        >
          <img v-if="!menuIsOpen" src="@/assets/images/icons/burger.svg" alt="" />
          <img v-else src="@/assets/images/icons/cross.svg" alt="" />
        </button>
      </nav>
    </div>
  </header>
</template>

<script>
import {useAuthStore, useEnabledStore} from "@/stores";
  import NavbarLogo from "./parts/NavbarLogo.vue";
  import TopNav from "./parts/TopNav.vue";
  import LoginBtn from "./parts/LoginBtn.vue";
  import MainNav from "./parts/MainNav.vue";
  import MobileNav from "./parts/MobileNav.vue";
  import ProfileLink from "@/components/layouts/header/parts/ProfileLink.vue";

  export default {
    props: {
      bookPortal: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        authStore: useAuthStore(),
        enabledStore: useEnabledStore(),
        menuIsOpen: false
      };
    },
    components: {
      ProfileLink,
      NavbarLogo,
      TopNav,
      LoginBtn,
      MainNav,
      MobileNav
    },
    computed: {
      isAuth() {
        return this.authStore.isAuth;
      },
      isPortalTypeBooks() {
        return this.enabledStore.portalTypeBooks;
      },
    }
  };
</script>

<style lang="scss">
  .header--6 {
    &.header {
      position: fixed;
      background-color: $main-dark;
      left: 0;
      right: 0;
      top: 0;
      z-index: 10;
      height: 70px;
      padding: 10px 0;

      .navbar {
        padding: 0;
        position: relative;
        gap: 6.25vw;
        justify-content: space-between;

        .side-menu {
          display: flex;
          gap: 2.08vw;
          margin-left: auto;
        }

        &.navbar--books {
          .side-menu {
            margin-left: 0;
          }
        }
      }

      .btn-menu {
        position: relative;
        z-index: 101;
        margin-left: auto;
        padding: 0;
        width: 24px;
        height: 24px;
      }

      @media (max-width: $breakpoint-xl) {
        height: 41px;
        padding: 4px 0;

        .navbar {
          &__logo {
            z-index: 10;
            width: 24px;
            height: 33px;
            img {
              object-fit: contain;
            }
          }
        }
        .mobile-menu {
          position: absolute;
          left: 0;
          top: -2000%;
          width: 100%;
          padding: 16px 16px 40px;
          background: $main-dark;
          z-index: 9;
          transition: $transition;

          .side-menu {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 16px;
            margin-top: 40px;
          }
          &.open {
            top: 100%;
          }
        }
      }
    }
  }
</style>
